import { gql } from '__generated__';

export default gql(`
  mutation DeleteTeam($id: ID!) {
    deleteTeam(id: $id)
  }
`);
